<template>
<div v-if="node" class="agFieldsSelector"> 
     <div class="agInputGroup agInputGroupInline">
        <label>Connection:</label>
        <b-form-select 
          class="agLargeInput"
          v-model="node.connection" 
          :options="connections" 
          :disabled="disableUI || isUpdatingSchemas"
          @change="connectionField_change">
        </b-form-select>
      </div>
      <div class="agInputGroup agInputGroupInline">
        <label>{{layerLabel}}</label>
        <b-form-select 
          class="agLargeInput"
          v-model="node.layer" 
          :options="layers" 
          :disabled="disableUI || layers.length == 0 || isUpdatingSchemas" 
          @change="layerField_change">
        </b-form-select>
      </div>
      <b-button class="agTextButton agInputGroup-append" :disabled="disableUI || !node.connection || isUpdatingSchemas" @click="refreshSchemasButton_click">Refresh</b-button>
      <div style="display: table-caption;" v-if="childTypes.length > 0" class="agFieldsSelector-childObjects agInputGroup">
      <label>Child Objects:</label>
      <div
        style="display: inline-flex; justify-content: end;"
        v-for="(child, index) in node.childObjects"
        :key="index"
        class="agFieldsSelector-childObject agInputGroup">
        <label>{{child.shortname}}:</label>
        <b-form-select
          v-model="child.name"
          class="agMediumInput"
          :options="childTypes"
          :disabled="childTypes.length <= 0 || isUpdatingSchemas"
          @change="childObjectField_change(child, index)"
        ></b-form-select>
        <div style="display:flex; flex-direction:column; margin-left:12px;">
          <label v-if="index<=0" style="text-align:center; margin-top:-20%">Alias</label>
          <b-input type="text" v-model="child.value" class="agSmallInput" :disabled="childTypes.length <= 0 || isUpdatingSchemas"></b-input>
        </div>
        <b-button
          v-if="index != node.childObjects.length - 1"
          class="agFieldsSelector-deleteChildObjectButton agDeleteButton agImageButton"
          style="margin-right:-2rem; margin-top: 10px"
          :disabled="disableUI"
          @click="deleteChildObjectButton_click(child, index)">
          <fa icon="times" />
        </b-button>
      </div>
    </div>
      <div class="agInputGroup">
        <label>Fields:</label>
        <b-input class="agFieldsSelector-fieldSearch" v-model="fieldSearchText" type="text" autocomplete="false" placeholder="Search fields..."></b-input>
        <button class="agTextButton agInputGroup-append" @click="clearFieldSearchButton_click">Clear</button>
        <div class="agFieldsSelector-hideUnselectedFields">
          <input type="checkbox" v-model="hideUnselectedFields"/>
          <label>Hide unselected fields</label>
        </div>
        <b-table 
          :key="'fields-' + reloadFields"
          class="agFieldsSelector-fieldsTable agFillLastCol"
          :fields="fieldHeaders"
          :items="filteredFields"
          :sort-compare="fieldsTable_sort"
          :thead-class="{'theadHidden': isUpdatingSchemas }"
          borderless
          outlined
          small>   
          <template #head(enabled)>
              <input type="checkbox" v-model="fieldsEnableAll" :disabled="disableUI" @click="fieldsEnableAll_click"/>
            </template>
          <template #cell(enabled)="data">
            <input type="checkbox" :key="data.item.key" v-model="data.item.enabled" :disabled="disableUI || data.item.locked"/>
          </template>
          <template #cell(field)="data">
            <div v-if="!data.item.nullable"><b>{{data.item.field}}</b></div>
            <div v-else>{{data.item.field}}</div>
          </template>  
          <template #cell(alias)="data">
            <div v-if="!data.item.nullable"><b>{{data.item.alias}}</b></div>
            <div v-else>{{data.item.alias}}</div>          
          </template>  
          <template #cell(type)="data">
            <div v-if="!data.item.nullable"><b>{{data.item.type}}</b></div>
            <div v-else>{{data.item.type}}</div>          
          </template>    
       </b-table>
       <b-spinner v-if="isUpdatingSchemas" class="agFieldsSelector-fieldsTableSpinner"></b-spinner>
      </div>
</div>    
</template>






<script>

// components

// modules
import Server from "src/server";
import Util from "src/util/util";


export default {
    name: "ag-fields-selector",
    components: {
    },
    props:{
        node: Object,
        disableUI: Boolean,
        connections: Array,
        hasChildObjects: Boolean
    },
    data(){
        return {
            isUpdatingSchemas: false,
            reloadFields: 0,
            layers: [],
            childTypes: [],
            fields: [],
            fieldSearchText: "",
            fieldHeaders: [
                {key: "enabled", sortable: false},
                {key: "field", sortable: true, class:"agFieldsSelector-fieldsTableCell"},
                {key: "alias", sortable: true, class:"agFieldsSelector-fieldsTableCell"},
                {key: "type", sortable: false, class:"agFieldsSelector-fieldsTableCell"},
            ],
            fieldsEnableAll: false,
            hideUnselectedFields: false,
        };
    },
    computed: {

        layerLabel() {
          if(this.node.connection && this.node.connection.type == "max") {
            return "Object:";
          }
          return "Layer:";
        },

        filteredFields() {
          var filteredFields = this.fields;

          if(this.fieldSearchText)
            filteredFields = filteredFields.filter(a => (a.field && a.field.toLowerCase().indexOf(this.fieldSearchText.toLowerCase()) > -1) || (a.alias && a.alias.toLowerCase().indexOf(this.fieldSearchText.toLowerCase()) > -1));
          
          if(this.hideUnselectedFields)
            filteredFields = filteredFields.filter(a => a.enabled);

          return filteredFields;
        },

        nextChild() {
            var num = 0;
            for (var i = 0; i < this.node.childObjects.length; i++) {
                var child = this.node.childObjects[i];
                var childNum = parseInt(child.shortname.replace("C-", ""));
                if (num <= childNum) {
                num = childNum;
                }
            }
            return num + 1;
        },
       
    },
    watch: {
      
    },

    created() {

    },

    mounted() {
      
    },

    methods: {

        // UI Events

        async refreshSchemasButton_click() {
            this.isUpdatingSchemas = true;
            this.layers = [];
            this.fields = [];
            console.log("node it ",this.node);
            var result = await this.$store.dispatch("connStore/updateSchemas", {connection: this.node.connection._id,layer:this.node.layer});
            this.node.connection = result.data.connection;

            this.$emit("refreshedSchemas");
            this.setLayers();
            this.setFields();
            this.isUpdatingSchemas = false;
        },

        connectionField_change() {
            this.$emit("connectionChanged");
            this.node.layer = null;
            this.setLayers();
        },

        layerField_change() {
          this.$emit("layerChanged");
          this.setFields();
        },

        fieldsEnableAll_click(e)
        {
            if(!this.node.connection || this.node.layer == null)
                return;

            var schema = this.node.connection.schemas.find(schema => schema.id == this.node.layer);
            if(!schema)
              return;   

            var enabled = e.currentTarget.checked;
            var keyField = schema.keyField;
            for(var i = 0; i < this.fields.length; i++)
            {
                var field = this.fields[i];
                if(field.field != keyField)
                  field.enabled = enabled;
            }
        },

        clearFieldSearchButton_click()
        {
          this.fieldSearchText = "";
        },

        childObjectField_change(child, index) {
            child.fields = [];
            this.addChildFields(child);

            // if bottom row add new empty child object as a placeholder
            if (index == this.node.childObjects.length - 1) {
                this.node.childObjects.push({
                name: "",
                shortname: "C-" + this.nextChild,
                fields: [],
                });
            }
        },

        deleteChildObjectButton_click(child, index) {
            this.removeChildFields(child);
            this.node.childObjects = Util.removeFromArrayByIndex( this.node.childObjects, index);

            // readjust shortnames
            var children = Util.copyArray(this.node.childObjects);
            this.node.childObjects = [];
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                var oldName = child.shortname;
                child.shortname = "C-" + this.nextChild;
                this.node.childObjects.push(child);

                // readjust fields
                for (var j = 0; j < this.fields.length; j++) {
                    var field = this.fields[j];
                    if (field.child == oldName) {
                        field.child = child.shortname;
                        field.field = field.field.replace(oldName, child.shortname);
                    }
                }
            }

            this.reloadFields++;
        },

        // emitted Events


        // other

        reset() {
          this.fieldSearchText = "";
          this.fieldsEnableAll = false;
          this.hideUnselectedFields = false;

          this.setLayers();
          this.setFields();
        },

         async setLayers() {
           this.layers = [];
           this.fields = [];

          if(this.node.connection) {
            for(var i = 0; i < this.node.connection.schemas.length; i++) {
              var schema = this.node.connection.schemas[i];
              var option = {value: schema.id, text: schema.name};
              this.layers.push(option);
            }
          }
        },

        async setFields() {

          var existingFields = this.fields;
          if(!existingFields || existingFields.length == 0)
            existingFields = this.node.fields;
          this.fields = [];

          if(!this.node.connection || this.node.layer == null)
            return;

          var schema = this.node.connection.schemas.find(schema => schema.id == this.node.layer);
          if(!schema)
            return;   

          for(var i = 0; i < schema.fields.length; i++) {
            var field = schema.fields[i];
            
            var enabled = false;
            if(existingFields && existingFields.indexOf(field.name) > -1)
              enabled = true;

            var locked = false;
            if(field.name == schema.keyField) {
              enabled = true;
              locked = true;
            }
            
            var option = {key:i,enabled: enabled, field: field.name, alias: field.alias, type: field.type.toLowerCase(), nullable: field.nullable, locked: locked};
            this.fields.push(option);
          }

          // check for child objects
          if(!this.hasChildObjects || !schema.childObjects || schema.childObjects.length == 0) 
              return;
          
          // add child object types and fields
          this.childTypes = [];
          var childObjects = Util.copyArray(this.node.childObjects);
          // loop through schemas
          for (var i = 0; i < schema.childObjects.length; i++) {
              var option = schema.childObjects[i];
              this.childTypes.push({
                  text: option.name,
                  value: option.name,
                  fields: option.fields,
              });
              var child = childObjects.find((a) => a.name == option.name);
              // if node has an instance of this child, add it's fields
              while (child) {
                  this.addChildFields(child);
                  childObjects = Util.removeFromArrayByKey(childObjects, "name", child.name);
                  child = childObjects.find((a) => a.name == option.name);
              }
          }
        },

        addChildFields(child) {
            // first, remove any exisiting fields for this child
            this.removeChildFields(child);

            var index = this.getChildFieldsIndex(child);
            if (!index) 
                index = this.fields.length;

            // grab  fields from option
            var childOption = this.childTypes.find((a) => a.text == child.name);
            var optionFields = childOption.fields;

            // make copy and temporary empty fields so table is blank while loading
            var fields = Util.copyArray(this.fields);
            this.fields = [];
            if (optionFields) {
                for (var i = 0; i < optionFields.length; i++) {
                var optionField = optionFields[i];
                var name = child.shortname + ": " + optionField.name;
                var enabled = false;
                if (child.fields.indexOf(optionField.name) > -1)
                    enabled = true;

                var field = {
                    enabled: enabled,
                    field: name,
                    alias: optionField.alias,
                    type: optionField.type.toLowerCase(),
                    child: child.shortname,
                    nullable: optionField.nullable
                };
                fields = Util.insertInArray(fields, index, field);
                index++;
                }
            }

            this.fields = fields;
        },

        removeChildFields(child) {
            var fields = Util.copyArray(this.fields);
            for (var i = 0; i < this.fields.length; i++) {
                var field = this.fields[i];
                if (field.child == child.shortname) {
                fields = Util.removeFromArrayByKey(fields, "child", child.shortname);
                }
            }

            this.fields = Util.copyArray(fields);
        },

        getChildFieldsIndex(child) {
            // remove C- and to get child number
            var childNum = child.shortname.replace("C-", "");
            childNum = parseInt(childNum);

            for (var i = 0; i < this.fields.length; i++) {
                var field = this.fields[i];

                if (field.field.substring(0, 2) == "C-") {
                var fieldChild = field.field.replace("C-", "");
                fieldChild = fieldChild.substring(0, fieldChild.indexOf(":"));
                fieldChild = parseInt(fieldChild);
                if (childNum < fieldChild) {
                    return i;
                }
                }
            }
        },


        fieldsTable_sort(aRow, bRow, key, sortDesc) {
            // keep child records at bottom and in order by child
            if (aRow.field.indexOf("C-") == 0 && bRow.field.indexOf("C-") == 0) {
                var aChildNum = aRow.field.replace("C-", "");
                aChildNum = aChildNum.substring(0, aChildNum.indexOf(":"));
                aChildNum = parseInt(aChildNum);
                var bChildNum = bRow.field.replace("C-", "");
                bChildNum = bChildNum.substring(0, bChildNum.indexOf(":"));
                bChildNum = parseInt(bChildNum);

                if (aChildNum == bChildNum) {
                    var aField = aRow.field.replace("C-" + aChildNum + ": ", "");
                    var bField = bRow.field.replace("C-" + bChildNum + ": ", "");

                    // now follow regular sort rules
                    if (key == "field") {
                        if (sortDesc)
                            return aField < bField;
                        else
                          return aField > bField;
                    } 
                    else {
                        // if both alias' are null sort by field
                        if (aRow.alias == null && bRow.alias == null)
                            return aField < bField ? -1 : aField > bField ? 1 : 0;
                        else if (aRow.alias == null) {
                            if (sortDesc) 
                                return 1;
                            else 
                                return -1;
                        } 
                        else if (bRow.alias == null) {
                            if (sortDesc)  
                                return -1;
                            else 
                                return 1;
                        }
                        return aRow.alias < bRow.alias ? -1 : aRow.alias > bRow.alias ? 1 : 0;
                    }
                }
            } else if (aRow.field.indexOf("C-") == 0) {
                if (sortDesc) 
                    return -1;
                else 
                    return 1;
            } 
            else if (bRow.field.indexOf("C-") == 0) {
                if (sortDesc) 
                    return 1;
                else 
                    return -1;
            } 
            else if (key == "field") {
                if (sortDesc)
                    return aRow < bRow;
                else
                    return aRow > bRow;
            } 
            else if (key == "alias") {
                // if both alias' are null sort by field
                if (aRow.alias == null && bRow.alias == null)
                    return aRow.field < bRow.field ? -1 : aRow.field > bRow.field ? 1 : 0;
                else if (aRow.alias == null) {
                    if (sortDesc) 
                        return 1;
                    else 
                        return -1;
                } 
                else if (bRow.alias == null) {
                    if (sortDesc) 
                        return -1;
                    else 
                        return 1;
                }
                return aRow.alias < bRow.alias ? -1 : aRow.alias > bRow.alias ? 1 : 0;
            }
        },
    }
}

</script>






<style scoped lang="css">

.agFieldsSelector-childObjects {
  position: relative;
  left: 476px;
}

.agFieldsSelector-childObject {
  margin-left: 55px;
}

.agFieldsSelector-childObject label {
  text-align: right;
}

.agFieldsSelector-deleteChildObjectButton {
  position: absolute;
  margin-left: 10px;
  margin-top: 5px;
  font-size: 20px;
}

.agFieldsSelector-fieldsTable
{
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 155px);
  height: 175px;
  margin: 5px 0px 0px 100px;
  overflow: auto;
  border-collapse: collapse;
  text-align: left;
}

.agFieldsSelector-fieldsTableSpinner {
  position: relative;
  left: -500px;
  top: 75px;
}

.agFieldsSelector-fieldSearch {
  width: calc(100% - 200px);
}

.agFieldsSelector-hideUnselectedFields {
  position: relative;
  left: 139px;
  top: 10px;
  margin-bottom: 5px;
  text-align: left;
}

</style>

<style lang="css">

.agFieldsSelector-fieldsTable .agFieldsSelector-fieldsTableCell {
  min-width: 125px !important;
}

</style>




// WEBPACK FOOTER //
// src/components/ui/FieldsSelector.vue